/**
 * I think this was meant to be deprecated, not depreciated.
 * @deprecated Use STATIC (or 'SINGLE') instead
 */
export const STATIC_DEPRECIATED = 'STATIC';
export const STATIC = 'SINGLE';
export const PROPERTY = 'PROPERTY';
export const EXTERNAL = 'EXTERNAL';
export const MULTI = 'MULTI';
export const RELATIVE_DATETIME = 'RELATIVE_DATETIME';
export const FIELD_DATA = 'FIELD_DATA';
export const FETCHED_OBJECT_PROPERTY = 'FETCHED_OBJECT_PROPERTY';
export const ENROLLMENT_EVENT_PROPERTY = 'ENROLLMENT_EVENT_PROPERTY';
export const SINGLE_OBJECT_COORDINATES = 'SINGLE_OBJECT_COORDINATES';
export const ENROLLMENT_DATASET_COLUMN = 'ENROLLMENT_DATASET_COLUMN';